module.exports = __webpack_public_path__ + "media/images/green-icon-c839d75a27832f8bc674969d40e9af66.svg";